import qs from 'qs';
import client, { url } from './client';

export const patch = ({ clubID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.get(`${url}/api/clubs/club/patch/${clubID}?${queryString}`);
};

export const loadAllClubs = ({ playerID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.get(`${url}/api/clubs/all/${playerID}?${queryString}`);
};

export const loadClubList = ({ centerID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.get(`${url}/api/clubs/${centerID}?${queryString}`);
};

export const loadCenters = ({ socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.get(`${url}/api/clubs/centers?${queryString}`);
};

export const updateCenterManagerFlag = ({ centerID, managerFlag, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.patch(`${url}/api/clubs/center/managerflagmodify/${centerID}?${queryString}`, {
    managerFlag,
  });
};

export const getPlayerByAccount = ({ account, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.get(`${url}/api/clubs/player-by-account/${encodeURIComponent(account)}?${queryString}`);
};

export const registCenter = ({ name, account, centerName, password, phone, sex, birth, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.post(`${url}/api/clubs/center?${queryString}`, {
    name,
    account,
    centerName,
    password,
    phone,
    sex,
    birth,
  });
};

export const readClub = ({ clubID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.get(`${url}/api/clubs/club/${clubID}?${queryString}`);
};

export const change = ({ clubID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.patch(`${url}/api/clubs/club/change/${clubID}?${queryString}`);
};

export const regist = ({
  centerID,
  name,
  ownerID,
  phone,
  address,
  socketKey,
}) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.post(`${url}/api/clubs/club?${queryString}`, {
    address,
    centerID,
    name,
    ownerID,
    phone,
  });
};

export const modifyClub = ({
  centerID,
  clubID,
  name,
  ownerID,
  pointActive,
  clubPointInfos,
  phone,
  address,
  membershipActive,
  clubDoorInfos,
  clubDoorSecondQRInfos,
  clubDoorDeviceInfos,
  socketKey,
}) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.patch(`${url}/api/clubs/club/${clubID}?${queryString}`, {
    centerID,
    name,
    ownerID,
    pointActive,
    clubPointInfos,
    membershipActive,
    phone,
    address,
    clubDoorInfos,
    clubDoorSecondQRInfos,
    clubDoorDeviceInfos,
  });
};

export const removeClub = ({ clubID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.delete(`${url}/api/clubs/club/${clubID}?${queryString}`);
};

export const loadAddressData = async ({clubAddress}) => {
  const url = `https://dapi.kakao.com/v2/local/search/address.json?&query=${clubAddress}`;
  let adressData = await fetch(url, {headers: {"Authorization":"KakaoAK 93a78abe4b26c4f8b04e8dbf84e02fa5"}}).then(res => res.json())
  let res = {data: adressData}

  return res;
}

// 전자계약서 관련 API
export const loadEContract = ({ clubID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.get(`${url}/api/clubs/club/econtract/${clubID}?${queryString}`);
};

export const updateEContract = ({ clubID, eContractID, title, text, stempURL, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.patch(`${url}/api/clubs/club/econtract/${clubID}?${queryString}`, {
    eContractID,
    title,
    text,
    stempURL,
  });
};

export const updateEContractActive = ({ clubID, eContractActive, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.patch(`${url}/api/clubs/club/econtract/activeupdate/${clubID}?${queryString}`, {
    eContractActive,
  });
};

export const updateEContractInfo = ({ clubID, coachActive, registActive, kioskActive, currentID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.patch(`${url}/api/clubs/club/econtract/info/${clubID}?${queryString}`, {
    coachActive,
    registActive,
    kioskActive,
    currentID,
  });
};

export const deleteEContract = ({ clubID, eContractID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.delete(`${url}/api/clubs/club/econtract/${clubID}?${queryString}`, {
    data: { eContractID },
  });
};

export const getMemberPassword = ({ playerID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.get(`${url}/api/clubs/club/member/password/${playerID}?${queryString}`);
};

export const loadClubRegistNumber = ({ clubID, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.get(`${url}/api/clubs/club/registnumber/${clubID}?${queryString}`);
};

export const updateClubRegistNumber = ({ clubID, registNumber, socketKey }) => {
  const queryString = qs.stringify({
    socketKey,
  });
  return client.patch(`${url}/api/clubs/club/registnumberupdate/${clubID}?${queryString}`, {
    registNumber,
  });
};